module.exports = __webpack_public_path__ + "assets/gmail1.14d6f411.svg";